import { Props } from './types';
import S from './ItemOverviewStyles';
import { FeaturesManagement } from '../../../../featuresControl';
import ImageWithFallback from '../../ImageWithFallback/ImageWithFallback';

function ItemOverview({
  avatar,
  avatarAlt,
  title,
  subtitle,
  isRoundImage,
  isVideoThumbnail,
  isIcon,
  onMouseOver,
  onMouseOut,
  onAvatarClick,
  avatarActionLabel,

}: Props): JSX.Element {
  const imgClass = `avatar${isRoundImage ? ' round' : ''}${isVideoThumbnail ? ' video' : ''}${isIcon ? ' icon' : ''}`;
  const avatarImage = (
    <ImageWithFallback
      src={FeaturesManagement.productivity.thumbnails ? avatar : undefined}
      alt={avatarAlt || ''}
    />
  );
  return (
    <S.Wrapper
      className="overview-container"
    >
      {avatar && (
        <div className={imgClass} onMouseOver={onMouseOver} onMouseOut={onMouseOut} onFocus={onMouseOver} onBlur={onMouseOut}>
          {onAvatarClick ? (
            <button
              type="button"
              className="avatar-button"
              title={avatarActionLabel}
              aria-label={avatarActionLabel}
              onClick={onAvatarClick}
            >
              {avatarImage}
            </button>
          ) : avatarImage}
        </div>
      )}
      <div className="description">
        <p className="title"> {title || ''} </p>
        <p className="subtitle"> {subtitle} </p>
      </div>
    </S.Wrapper>
  );
}

export default ItemOverview;
